/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
// eslint-disable-next-line react/prop-types
function Edit({ width = 16.023, height = 16, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16.023 16"
      {...props}
    >
      <path
        id="edit_FILL0_wght400_GRAD0_opsz24_1_"
        data-name="edit_FILL0_wght400_GRAD0_opsz24 (1)"
        d="M4.753,17H5.981l7.562-7.562L12.315,8.208,4.753,15.769ZM17.29,8.164,13.564,4.482l1.227-1.227a1.773,1.773,0,0,1,2.477,0L18.5,4.482A1.738,1.738,0,0,1,19.022,5.7a1.583,1.583,0,0,1-.482,1.216ZM16.019,9.457,6.726,18.75H3V15.024l9.293-9.293Zm-3.09-.636-.614-.614,1.227,1.227Z"
        transform="translate(-3 -2.75)"
        fill="#8c8c8c"
      />
    </svg>
  );
}
export default Edit;
